// This component wraps Tolgee's T component to provide default values based on the key naming
// convention we have adopted at Platformed.

import {T as TOrig, PropsWithKeyName, useTolgee} from "@tolgee/react";
import {memo, useEffect} from "react";
import {deriveDefaultValueFromKeyName, deriveGibberishFromKeyName} from "./useTranslate";
import {convertToTolgeeLanguageCode} from ".";

const T = memo(({defaultValue, keyName, language, ...props}: PropsWithKeyName) => {
  const tolgee = useTolgee(["language"]);
  const convertedLanguage = language ? convertToTolgeeLanguageCode(language) : undefined;

  // If using a non-default language, ensure the translation record is loaded
  useEffect(() => {
    if (convertedLanguage) {
      tolgee.loadRecord({language: convertedLanguage}, {useCache: true});
    }
  }, [convertedLanguage, tolgee]);

  const currentLanguage = convertedLanguage ?? tolgee.getLanguage();
  if (currentLanguage === "xx") {
    return deriveGibberishFromKeyName(keyName);
  }
  const newDefaultValue = defaultValue ?? deriveDefaultValueFromKeyName(keyName);
  return <TOrig defaultValue={newDefaultValue} keyName={keyName} language={convertedLanguage} {...props} />;
});

export default T;
